/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M6 7.99999H13.5C15.9853 7.99999 18 10.0147 18 12.5V12.5C18 14.9853 15.9853 17 13.5 17H11M6 7.99999L8 6M6 7.99999L8 9.99999"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M6 7.99999H13.5C15.9853 7.99999 18 10.0147 18 12.5V12.5C18 14.9853 15.9853 17 13.5 17H11M6 7.99999L8 6M6 7.99999L8 9.99999M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM8.53033 6.53033C8.82322 6.23744 8.82322 5.76257 8.53033 5.46967C8.23744 5.17678 7.76257 5.17678 7.46967 5.46967L5.46967 7.46966C5.32902 7.61031 5.25 7.80107 5.25 7.99999C5.25 8.1989 5.32902 8.38966 5.46967 8.53032L7.46967 10.5303C7.76256 10.8232 8.23744 10.8232 8.53033 10.5303C8.82322 10.2374 8.82322 9.76255 8.53033 9.46966L7.81066 8.74999H13.5C15.5711 8.74999 17.25 10.4289 17.25 12.5C17.25 14.5711 15.5711 16.25 13.5 16.25H11C10.5858 16.25 10.25 16.5858 10.25 17C10.25 17.4142 10.5858 17.75 11 17.75H13.5C16.3995 17.75 18.75 15.3995 18.75 12.5C18.75 9.6005 16.3995 7.24999 13.5 7.24999H7.81067L8.53033 6.53033Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M22 9.5V9V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H15C16.8613 22 17.7919 22 18.5451 21.7553C20.0673 21.2607 21.2607 20.0673 21.7553 18.5451C22 17.7919 22 16.8613 22 15V15V14.5M6 7.99999H13.5C15.9853 7.99999 18 10.0147 18 12.5V12.5C18 14.9853 15.9853 17 13.5 17H11M6 7.99999L8 6M6 7.99999L8 9.99999"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M6 7.99999H13.5C15.9853 7.99999 18 10.0147 18 12.5V12.5C18 14.9853 15.9853 17 13.5 17H11M6 7.99999L8 6M6 7.99999L8 9.99999M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.53033 5.46967C8.82322 5.76257 8.82322 6.23744 8.53033 6.53033L7.81067 7.24999H13.5C16.3995 7.24999 18.75 9.6005 18.75 12.5C18.75 15.3995 16.3995 17.75 13.5 17.75H11C10.5858 17.75 10.25 17.4142 10.25 17C10.25 16.5858 10.5858 16.25 11 16.25H13.5C15.5711 16.25 17.25 14.5711 17.25 12.5C17.25 10.4289 15.5711 8.74999 13.5 8.74999H7.81066L8.53033 9.46966C8.82322 9.76255 8.82322 10.2374 8.53033 10.5303C8.23744 10.8232 7.76256 10.8232 7.46967 10.5303L5.46967 8.53032C5.32902 8.38966 5.25 8.1989 5.25 7.99999C5.25 7.80107 5.32902 7.61031 5.46967 7.46965L7.46967 5.46967C7.76257 5.17678 8.23744 5.17678 8.53033 5.46967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
